import { render } from "./blog-2.vue?vue&type=template&id=715da3ab"
import script from "./blog-2.vue?vue&type=script&lang=js"
export * from "./blog-2.vue?vue&type=script&lang=js"

import "./blog-2.vue?vue&type=style&index=0&id=715da3ab&lang=less"

import exportComponent from "/var/jenkins_home/workspace/give-circle-intro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__